<script>
    import TextField from "../controls/TextField.svelte";
    import TextFieldPassword from "../controls/TextFieldPassword.svelte";
    import ButtonDefault from "../controls/ButtonDefault.svelte";

    export let onNavigateToLogin;

    let emailTextField;
    let pwTextField;
    let confirmPwTextField;
    let errorMessage = "";
    let rawResult = "";

    async function handleRegister(event) {
        event.preventDefault();

        const email = emailTextField.value;
        const password = pwTextField.value;
        const confirmPassword = confirmPwTextField.value;

        if (!email || !password || !confirmPassword) {
            errorMessage = "Please fill in all fields.";
            return;
        }

        if (password !== confirmPassword) {
            errorMessage = "Passwords do not match.";
            return;
        }

        errorMessage = "";

        try {
            const response = await fetch("https://www.deckblox.app/rest/register", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({email, password}),
                credentials: "include"
            });

            const text = await response.text();
			rawResult = text;
			let data;
			try {
				data = JSON.parse(text);
			} catch (parseError) {
				errorMessage = `Failed to parse JSON: ${parseError.message}`;
				return;
			}
			if (!response.ok) {
				errorMessage = data.message
					? `${data.message} (Error ${response.status})`
					: `Registration failed with status ${response.status}`;
				return;
			}
			window.location.href = "/";

        } catch (error) {
            errorMessage = `Failed to register. Please try again. Reason: ${error.message}`;
        }
    }
</script>

<div class="flex flex-grow items-center justify-center bg-[var(--app-bg-level1)]"> 
    <form class="w-full max-w-sm bg-[var(--app-bg-level4)] p-6 rounded-lg shadow-md -translate-y-20" on:submit={handleRegister}>
        <h2 class="text-xl font-bold mb-4 text-white">Create Account</h2>

        <div class="mb-4">
            <TextField
                placeholder="Enter your email"
                label="Email"
                bind:this={emailTextField}
            />
        </div>

        <div class="mb-4">
            <TextFieldPassword
                placeholder="Enter your password"
                label="Password"
                bind:this={pwTextField}
            />
        </div>

        <div class="mb-4">
            <TextFieldPassword
                placeholder="Confirm your password"
                label="Confirm Password"
                bind:this={confirmPwTextField}
            />
        </div>

        {#if errorMessage}
            <p class="text-sm text-red-500">{errorMessage}</p>
        {/if}

        {#if rawResult}
			<pre class="text-xs text-gray-300">{rawResult}</pre>
		{/if}

        <div class="mt-4">
            <ButtonDefault text="Create Account" isEnabled={true} on:click={handleRegister} />
        </div>

        <div class="mt-4 text-center">
			<button class="text-sm text-gray-500 hover:underline border border-transparent" on:click={onNavigateToLogin}>
				Already have an account? Log in
			</button>
		</div>
    </form>
</div>
